import { useBrandFilter } from "../../../../hooks/useBrandFilter"
import { Select } from "../../../../module/brand-filter/components/select/Select"
import { RadioButtonsGroup } from "../../radioButtonsGroup/RadioButtonsGroup"
import styles from "./brandFilterOptions.module.css"
import { Button } from "../../../ui/button/Button"

export function BrandFilterOptions({ closeModal }) {
    const { brandId, nameV, carTypeId,
        handleBrandIdChange, handle_car_model_id_change, handleNameVChange, handleSearchClick, handleCarTypeChange,
        brandsData, modelsData, volumeNameData, car_model_id,
        isLoadingBrands, isLoadingModels, isLoadingVolume, isLoadingEngineProduct, isRefetching
    } = useBrandFilter()





    return (
        <div className={styles.brand_filter}>
            <div className={styles.filter_container} >
                <p className={styles.heading}>Фильтр по марке <br />
                    и модели автомобиля: </p>
                <RadioButtonsGroup onChange={handleCarTypeChange} value={carTypeId} />
            </div>
            <div className={styles.selects_container} >
                <div className={styles.select_container}>
                    <p className={styles.select_name}>Марка автомобиля</p>
                    <Select disabled={!carTypeId || isLoadingBrands} isLoading={isLoadingBrands} items={brandsData || []} placeholder={"Укажите марку"} setValue={handleBrandIdChange} value={brandId} />
                </div>
                <div className={styles.select_container}>
                    <p className={styles.select_name}>Модель автомобиля</p>
                    <Select disabled={!brandId || isLoadingModels} isLoading={isLoadingModels} items={modelsData || []} placeholder={"Укажите модель"} setValue={handle_car_model_id_change} value={car_model_id} />
                </div>
                <div className={styles.select_container}>
                    <p className={styles.select_name}>Объем двигателя</p>
                    <Select disabled={!car_model_id || isLoadingVolume} isLoading={isLoadingVolume} items={volumeNameData || []} placeholder={"Укажите объем"} setValue={handleNameVChange} value={nameV} />
                </div>
                <div className={styles.grid_button}>
                    <Button disabled={!nameV || isLoadingEngineProduct || isRefetching} onClick={handleSearchClick} fontWeight="bold" variant={"yellow"} width={"full"}>Поиск</Button>
                </div>
            </div>
        </div>
    )
}
